export const VISIBILITY_FILTERS = {
  ALL: 'all',
  SHOW_FIVE: 5,
  SHOW_SEVEN: 7,
  SHOW_TEN: 10,
};